import { openInNewTab } from './open-in-new-tab';
import { isWpsEnv } from './get-user-info';

/** 获取环境信息 */
const getEnvInfo = () => {
  const isWps = isWpsEnv();
  if (isWps) {
    return window.common?.env?.getClientAppInfo();
  }

  return Promise.resolve();
};

export const openFeedbackPage = () => {
  getEnvInfo()?.then((envData) => {
    const isWps = isWpsEnv();
    // 强制指定到反馈页
    const toDetailPage = '&tofeedback=true';
    // 产品ID
    const productIdQuery = 'product_id=1000143';
    // 产品名称
    const productNameQuery = `product_name=${encodeURIComponent('新建应用')}`;
    // 客户端类型
    const app_type = isWps ? 'app_type=client' : 'app_type=web';
    // 来源名称
    const app_name = 'app_name=newpage';
    // 来源版本号
    const appVersion = `app_version=${envData?.version || ''}`;
    // 来源渠道号
    const appDistQuery = `app_dist=${envData?.channel || ''}`;

    const feedbackUrl = `https://get.wps.cn/feedback/pc?${productIdQuery}&${productNameQuery}&${app_type}&${app_name}&${appVersion}&${appDistQuery}&${toDetailPage}`;
    openInNewTab({ url: feedbackUrl });
  });
};
